// extracted by mini-css-extract-plugin
export default {"root":"LoadingStateBlock_root__zHtdo"};